module.exports = __webpack_public_path__ + "img/b2-4.e18bbc7.png";